import { render, staticRenderFns } from "./InfiniteCarousel.vue?vue&type=template&id=1a64880a&scoped=true"
import script from "./InfiniteCarousel.vue?vue&type=script&lang=js"
export * from "./InfiniteCarousel.vue?vue&type=script&lang=js"
import style0 from "./InfiniteCarousel.vue?vue&type=style&index=0&id=1a64880a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64880a",
  null
  
)

export default component.exports